var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaffReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20171 49.0892C10.5575 49.5 12.3888 49.5 15.5017 49.5H38.9017C42.0146 49.5 43.8458 49.5 45.2016 49.0892M9.20171 49.0892C8.91101 49.0012 8.64216 48.8942 8.38722 48.7643C7.11713 48.1171 6.08451 47.0845 5.43737 45.8144C4.70166 44.3705 4.70166 42.4804 4.70166 38.7V15.3C4.70166 11.5196 4.70166 9.62947 5.43737 8.18556C6.08451 6.91547 7.11713 5.88285 8.38722 5.23571C9.83113 4.5 11.7213 4.5 15.5017 4.5H38.9017C42.682 4.5 44.5722 4.5 46.0161 5.23571C47.2862 5.88285 48.3188 6.91547 48.966 8.18556C49.7017 9.62947 49.7017 11.5196 49.7017 15.3V38.7C49.7017 42.4804 49.7017 44.3705 48.966 45.8144C48.3188 47.0845 47.2862 48.1171 46.0161 48.7643C45.7612 48.8942 45.4923 49.0012 45.2016 49.0892M9.20171 49.0892C9.20245 47.2682 9.21337 46.3047 9.37459 45.4942C10.0848 41.924 12.8756 39.1331 16.4458 38.4229C17.3152 38.25 18.3607 38.25 20.4517 38.25H33.9517C36.0426 38.25 37.0881 38.25 37.9575 38.4229C41.5277 39.1331 44.3186 41.924 45.0287 45.4942C45.1899 46.3047 45.2009 47.2682 45.2016 49.0892M36.2017 21.375C36.2017 26.3456 32.1722 30.375 27.2017 30.375C22.2311 30.375 18.2017 26.3456 18.2017 21.375C18.2017 16.4044 22.2311 12.375 27.2017 12.375C32.1722 12.375 36.2017 16.4044 36.2017 21.375Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffReports);
export default __webpack_public_path__ + "static/media/StaffReports.8ecc741ceae05acb163672d9aee5a594.svg";
export { ForwardRef as ReactComponent };